import type { Project } from "@/graphql.ts";
import { isAdminRole } from "@/redux/modules/project.ts";

export const isLastAdmin = (project: Project): boolean => {
  // a user is the last admin if he is admin and there is exactly one admin
  return !!(
    !!project &&
    project.isUserAdmin &&
    project.projectMembers?.filter((m) => isAdminRole(m?.roleId) ?? false)?.length === 1
  );
};
